export abstract class UpdateableList<InterfaceType> {
    private _data: InterfaceType[] = [];
    abstract order(a: InterfaceType, b: InterfaceType): number;
    abstract equal(a: InterfaceType, b: InterfaceType): boolean;

    public get data() {
        return this._data;
    }

    public set data(e: InterfaceType[]) {
        this._data = e;
        this.sort();
    }

    public push(e: InterfaceType) {
        this.data.push(e);
        this.sort();
    }

    public remove(e: InterfaceType) {
        let updated: InterfaceType[] = [];
        for (let item of this.data) {
            if (!this.equal(e, item)) {
                updated.push(item);
            }
        }

        this.data = updated;
    }

    public sort() {
        this._data = this._data.sort((a: InterfaceType, b: InterfaceType) =>
            this.order(a, b)
        );
    }

    public update(e: InterfaceType) {
        this.remove(e);
        this.push(e);
    }
}
